<button class="microsoftSignInButton" type="button" onclick="relocate()"><img class="microsoftLogo" src="../../assets/microsoftSignIn.jpg">{{ "signInWithMicrosoft" | translate }}</button>
